import {Component, Input} from '@angular/core';
import {EventItem, Lookups, Race} from "@model";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-result-list-item',
  templateUrl: './result-list-item.component.html',
  styleUrls: ['./result-list-item.component.scss']
})
export class ResultListItemComponent {
  @Input() race: Race | undefined;
  @Input() eventItem: EventItem | undefined;
  @Input({required:true}) languages: Lookups[] = [];

  constructor(public translocoService: TranslocoService) {}

}
